import * as React from "react";
import { ITypedOption } from "../../../models/common/typedOption";
import { ICompanyPage } from "../../../models/company/companyPage";
import { CompanyPageList } from "./CompanyPageList";
import { CompanyPageEdit } from "./CompanyPageEdit";
import { IAppSessionState } from "../../../models/store/storeTypes";
import { recordLockManager } from "../../../models/services/recordLockService";
import { abortManager } from "source/models/services/tokenService";

// CompanyPage
export interface ICompanyPageOwnProps {
}

export interface ICompanyPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    companyPage: ICompanyPage;
}

export interface ICompanyPageDispatchProps {
    onGetCompanyPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

type CompanyPageProp = ICompanyPageOwnProps & ICompanyPageStateProps & ICompanyPageDispatchProps;

export class CompanyPage extends React.Component<CompanyPageProp, {}> {
    constructor(props: CompanyPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
    }

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
    }
    
    render() {
        const props = this.props;
        const sessionState = props.appState.state;
        if (sessionState.isSuperAdmin) {
            return (
                <CompanyPageList
                    appState={props.appState}
                    dataId={props.dataId}
                    pageList={props.companyPage?.list}
                    onGetCompaniesPage={props.onGetCompanyPage}
                    onLogout={props.onLogout}
                    onSetCulture={props.onSetCulture}
                    onSaveUserParameters={props.onSaveUserParameters}
                    onRefreshSessionState={props.onRefreshSessionState}
                />
            );
        } else {
            return (
                <CompanyPageEdit
                    appState={props.appState}
                    dataId={props.dataId}
                    onLogout={props.onLogout}
                    onSetCulture={props.onSetCulture}
                    onSaveUserParameters={props.onSaveUserParameters}
                    onRefreshSessionState={props.onRefreshSessionState}
                />
            );
        }
    }
}